import { Box, Flex, Image } from '@chakra-ui/react';
import React from 'react';
import { IGame } from '../../../providers/Games/useGames';

interface IGameComponent {
	data: IGame;
	setAsActive: (target: IGame) => void;
	isActive: boolean;
	isBlack?: boolean;
}

export const Game = ({ data, setAsActive, isActive, isBlack }: IGameComponent) => (
	<Flex
		width="100%"
		position="relative"
		onClick={() => setAsActive(data)}
		cursor="pointer"
		borderRadius="6px"
		userSelect="none"
	>
		{/** 16:9 filler */}
		<Box
			width="100%"
			paddingBottom="56.25%"
			borderRadius="6px"
			color={isBlack ? "black" : "white"}
		/>
		<Image
			filter={isActive ? 'unset' : 'brightness(.33)'}
			src={data.media.coverImageUrl}
			position="absolute"
			top="0"
			left="0"
			width="100%"
			height="100%"
			zIndex="1"
			borderRadius="6px"
			pointerEvents="none"
		/>
		{isActive && (
			<Image
				src={data.media.coverImageUrl}
				position="absolute"
				top="0"
				left="0"
				zIndex="0"
				width="100%"
				height="100%"
				filter="blur(36px)"
				borderRadius="6px"
				pointerEvents="none"
			/>
		)}
	</Flex>
);
